<div class="max-w-5xl mx-auto rounded-xl p-8 mt-6 min-h-[60vh]">
  <div class="flex items-center gap-5 mb-10">
    <app-nav-button [route]="routeNav"></app-nav-button>
    <h2 class="text-2xl font-bold text-gray-800 flex items-center gap-2">
      Editar información de la compañía
    </h2>
  </div>
  <app-loading *ngIf="isLoading" [text]="'Cargando datos'"></app-loading>
  <form *ngIf="!isLoading" [formGroup]="companyForm" (ngSubmit)="onSubmit()" class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <app-input-select label="Departamento" placeholder="Departamento" [control]="companyForm.get('idDepartament')"
        [options]="departaments">
      </app-input-select>
      <app-input-select label="Provincia" placeholder="Provincia" [control]="companyForm.get('idProvince')"
        [options]="provinces">
      </app-input-select>
      <app-input-select label="Distrito" placeholder="Distrito" [control]="companyForm.get('idDistrict')"
        [options]="districts">
      </app-input-select>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <app-input-select label="Línea de negocio" placeholder="Línea de negocio"
        [control]="companyForm.get('idBusinessLine')" [options]="bussinessLines">
      </app-input-select>
      <app-input-text label="RUC" placeholder="RUC" [control]="companyForm.get('ruc')" />
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <app-input-text label="Nombre comercial" placeholder="Nombre comercial"
        [control]="companyForm.get('commercialName')" />
      <app-input-text label="Razón social" placeholder="Razón social" [control]="companyForm.get('socialReason')" />
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <app-input-textarea placeholder="Misión" label="Misión" [control]="companyForm.get('mission')" />
      <app-input-textarea placeholder="Visión" label="Visión" [control]="companyForm.get('vision')" />
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <app-input-textarea placeholder="Historia" label="Historia" [control]="companyForm.get('ourHistory')" />
      <app-input-textarea placeholder="Información de negocio" label="Información de negocio"
        [control]="companyForm.get('businessInformation')" />
    </div>
    <div>
      <app-input-text placeholder="Slogan" label="Slogan" [control]="companyForm.get('slogan')" />
    </div>
    <app-loading-button [text]="'Guardar cambios'" [loading]="loading" type="submit">
    </app-loading-button>
  </form>
</div>
